import { useAppSelector } from "store/hooks";
import { selectToken } from "store/slices/token";

export const useToken = () => useAppSelector(selectToken);
